/** Durações do LeadTalk/LeadMusic (a duração vem do backend, em segundos). */

/** Relógio do player: 205 → "3:25"; 3723 → "1:02:03". */
export function formatClock(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds || 0));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = String(total % 60).padStart(2, '0');
  return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
}

/** Minutos arredondados, nunca zero: 1060 → "18 min". */
export function formatMinutes(seconds: number): string {
  return `${Math.max(1, Math.round(seconds / 60))} min`;
}

/** Cartões e fila: episódio em minutos ("18 min"), música no relógio ("3:25"). */
export function formatDuration(seconds: number, talk: boolean): string {
  return talk ? formatMinutes(seconds) : formatClock(seconds);
}
